<div class="alternative-info">
  <div class="alternative-info__header">
    <div class="d-flex align-items-center">
      <p class="f-14 _fw-600 mb-0">ALTERNATIVE INFORMATION</p>
      <i
        class="pi pi-info-circle ml-2 cursor-pointer"
        pTooltip="Extra emails and mobiles for this contact. Add a name when they belong to another person sharing this contact, e.g. a partner on the same email."
        tooltipPosition="top"></i>
    </div>
    <button type="button" class="_outline-btn" (click)="addAlternative()" [disabled]="isReadonly">
      <i class="pi pi-plus f-12 mr-2"></i>Add Alternative
    </button>
  </div>

  <div class="alternative-info__row" *ngFor="let item of items; let i = index">
    <div class="alternative-info__field">
      <input
        type="text"
        class="site-input"
        [(ngModel)]="item.name"
        [ngModelOptions]="{ standalone: true }"
        [readonly]="isReadonly"
        placeholder="Alternate Name" />
    </div>
    <div class="alternative-info__field">
      <input
        type="email"
        class="site-input"
        [(ngModel)]="item.email"
        [ngModelOptions]="{ standalone: true }"
        [readonly]="isReadonly"
        placeholder="Alternate Email"
        [ngClass]="{ '_input-error': isInvalidEmail(item) }" />
      <p *ngIf="isInvalidEmail(item)" class="text-danger f-10 ml-2 mt-1">Invalid email format</p>
    </div>
    <div class="alternative-info__field">
      <input
        #mobileField
        type="text"
        class="site-input"
        [(ngModel)]="item.mobile_no"
        [ngModelOptions]="{ standalone: true }"
        [readonly]="isReadonly"
        appMobileMask
        placeholder="Alternate Mobile"
        (input)="onMobileInput(item, mobileField.value)" />
    </div>
    <div class="alternative-info__label">
      <ng-select
        [items]="labelOptions"
        [(ngModel)]="item.label"
        [ngModelOptions]="{ standalone: true }"
        [addTag]="addCustomLabel"
        addTagText="Add"
        [clearable]="true"
        [markFirst]="false"
        [readonly]="isReadonly"
        placeholder="Select Label"
        appendTo="body"></ng-select>
    </div>
    <span class="alternative-info__delete" [pTooltip]="item.lead_id ? 'Unassign Alternative Contact' : 'Remove'" tooltipPosition="top">
      <button
        type="button"
        class="icon_btn bg-none alternative-info__delete-btn"
        (click)="removeAlternative(i)"
        [disabled]="isReadonly || removingIndex !== null">
        <i class="pi f-16" [ngClass]="removingIndex === i ? 'pi-spin pi-spinner' : 'pi-trash'"></i>
      </button>
    </span>
  </div>
</div>
